import React from 'react';

export const setupWordpressSupport = () => {
  import('@wordpress/blocks').then(wpBlocks => {
    if (typeof wpBlocks.getCategories === 'function') {
      wpBlocks
        .getCategories()
        .splice(1, 0, {
          slug: 'cards',
          title: 'Encarts',
          icon: <></>,
        });
      wpBlocks
        .getCategories()
        .splice(1, 0, {
          slug: 'text-images',
          title: 'Texte + Image',
          icon: <></>,
        });
      wpBlocks
        .getCategories()
        .splice(1, 0, {
          slug: 'contenu-text',
          title: 'Contenu Texte',
          icon: <></>,
        });
      wpBlocks
        .getCategories()
        .splice(1, 0, {
          slug: 'images',
          title: 'Images',
          icon: <></>,
        });
      wpBlocks
        .getCategories()
        .splice(1, 0, {
          slug: 'components',
          title: 'Composants',
          icon: <></>,
        });
    }
  });
};